import { Module } from "@interfaces/fc-user/permissions";

export const roles =  {
    OSA: "Organization Super Admin",
    OA: "Organization administrator",
    FD: "Front Desk",
    HP: "Health Professional",
    HO: "Health Operator"
};

export const drProxMenuSections:Module[] = [
    "calendar",
    "patients",
    "publicProfile",
    "services",
    "devices",
    "chat",
    "quiz",
    "blog",
    "org"
];

// export const reportsSection:Module[] = [
//     "reports",
//     "dashboard",
//     "patients",
//     "services",
//     "appointments",
//     "financial"
// ];
// export const drProxSections:Module[] = [
//     "calendar",
//     "patients",
//     "publicProfile",
//     "services",
//     "devices",
//     "chat",
//     "quiz",
//     "blog",
//     "org",
//     "newPatient",
//     "newDiagnosis",
//     "scheduleAppointment",
//     "editAppointment",
//     "viewFile",
//     "personalInfo",
//     "recordDetails",
//     "newAppointment",
//     "newRecord",
//     "documents",
//     "studies",
//     "addService",
//     "addOffice",
//     "addSchedule",
//     "account",
//     "reports"
// ];

export const sections = {
    calendar: ["OSA", "OA", "FD", "HP", "HO"],
    patients: ["OSA", "FD", "HP", "HO"],
    newPatient: ["OSA", "FD", "HP"],
    newDiagnosis: ["OSA", "HP"],
    scheduleAppointment: ["OSA", "FD", "HP", "HO"],
    editAppointment: ["OSA", "FD", "HP", "HO"],
    viewFile: ["OSA", "HP", "HO"],
    recordDetails: ["OSA", "FD", "HP", "HO"],
    newAppointment: ["OSA", "HP"],
    newRecord: ["OSA", "HP", "HO"],
    documents: ["OSA", "HP", "HO"],
    studies: ["OSA", "HP", "HO"],
    publicProfile: ["OSA", "OA"],
    offices: ["OSA", "HP"],
    addOffice: ["OSA"],
    services: ["OSA", "HP"],
    addService: ["OSA"],
    addSchedule: ["OSA", "OA", "HP"],
    account: ["OSA", "OA"],
    devices: ["OSA"],
    chat: ["OSA","HP"],
    quiz: ["OSA","HP"],
    blog: ["OSA"],
    org: ["OSA", "OA"],
    reports: ["OSA", "HP"],
    myServices: ["OSA", "HP"]
};